import * as serviceWorker from '../serviceWorker'

/**
 * Register service worker with promise-based interface
 */
function registerServiceWorker() {
    return new Promise((resolve) => {
        const onUpdate = (registration) => {
            resolve({ update: true, registration })
        }
        const onSuccess = (registration) => {
            resolve({ update: false, registration })
        }
        // If you want your app to work offline and load faster, you can change
        // unregister() to register() below. Note this comes with some pitfalls.
        // Learn more about service workers: http://bit.ly/CRA-PWA
        serviceWorker.register({ onUpdate, onSuccess })
    })
}

export const registerServiceWorkerPromise = registerServiceWorker()